import React from 'react'
import {Link} from 'gatsby'
import { useEffect, useState } from 'react'
import anime, { easings, stagger } from 'animejs'
import logo from '../images/logo1.svg'
import scrollTo from 'gatsby-plugin-smoothscroll';

export default function Navbar() {
    const [navbar, setNavbar] = useState(false); // false -> navbar is hidden, true otherwise
    useEffect(() => {
        anime({
            targets: 'nav .l',
            translateY: [-100, 0],
            duration: 1000,
            easings: 'easeOutQuad',
            delay: anime.stagger(50)
        })
    }, [])

    function goToLoadingPage() {
        
    }

    useEffect(() => {
        var prevScrollpos = window.pageYOffset;
        window.onscroll = function() {
            var currentScrollPos = window.pageYOffset;
            if (prevScrollpos > currentScrollPos) {
                document.getElementById("navbar").style.top = "0";
            } else {
                document.getElementById("navbar").style.top = "-50%";
            }
            prevScrollpos = currentScrollPos;
        }
    })

    function changeNavbarStatus(){
        setNavbar(!navbar);
        var ham1 = document.getElementById("ham1");
        var ham2 = document.getElementById("ham2");
        var ham3 = document.getElementById("ham3");
        if(!navbar){
            ham1.classList.add("rotate-45");
            ham1.classList.add("scale-x-120");
            ham1.classList.add("translate-y-5");
            ham1.classList.add("mt-1");
            ham2.classList.add("opacity-0");
            ham3.classList.add("-rotate-45");
            ham3.classList.add("scale-x-120");
            ham3.classList.add("translate-y-1");
            ham3.classList.add("mt-1");
        }
        else{
            ham1.classList.remove("rotate-45");
            ham1.classList.remove("scale-x-120");
            ham1.classList.remove("translate-y-5");
            ham1.classList.remove("mt-1");
            ham2.classList.remove("opacity-0");
            ham3.classList.remove("-rotate-45");
            ham3.classList.remove("scale-x-120");
            ham3.classList.remove("translate-y-1");
        }
    }

    return (
        <div>
            <nav id="navbar" className="fixed hidden md:flex bg-black-400 border-b-2 border-dashed border-black-300 p-3 bg-opacity-80 backdrop-filter backdrop-blur-sm z-50 left-1/2 transform -translate-x-1/2  w-screen m-auto font-mono transition-all duration-1000">
                <div className="w-full ml-16 mr-16 md:flex space-x-5 m-auto justify-end items-center hidden">
                    <Link className="w-10 h-10 mr-auto cursor-pointer" to="/"><img src={logo} alt="" /></Link>
                    <span className="text-green-200 hover:text-green-300 uppercase cursor-pointer" onClick={() => scrollTo('#about')}>About</span>
                    {/* <span className="text-green-200 hover:text-green-300 l uppercase cursor-pointer" onClick={() => scrollTo('#experience')}>Experience</span> */}
                    <span className="text-green-200 hover:text-green-300 uppercase cursor-pointer" onClick={() => scrollTo('#projects')}>Projects</span>
                    <span className="text-green-200 hover:text-green-300 uppercase cursor-pointer" onClick={() => scrollTo('#skills')}>Skills</span>
                    <Link className="text-green-200 hover:text-green-300 uppercase" to="/blogs">Blogs</Link>
                    <span className="text-green-200 hover:text-green-300 uppercase cursor-pointer" onClick={() => scrollTo('#contact')}>Contact</span>
                </div>
            </nav>

            <div className="md:hidden fixed w-screen bg-black-700 bg-opacity-80 backdrop-filter backdrop-blur-sm top-0 right-0 z-50" onClick={changeNavbarStatus}>
                <div id="ham1" className="ml-auto h-1 w-10 bg-green-300 rounded-full mt-4 mr-4 transition-all duration-500"></div>
                <div id="ham2" className="ml-auto h-1 w-10 bg-green-300 rounded-full mt-1 mr-4 transition-all duration-500"></div>
                <div id="ham3" className="ml-auto mb-4 h-1 w-10 bg-green-300 rounded-full mt-1 mr-4 transition-all duration-500"></div>
            </div>
            
            {navbar && 
                <div className="md:hidden fixed top-0 left-0 z-40 bg-clip-padding backdrop-filter backdrop-blur-xl bg-opacity-80  h-screen w-screen text-2xl group">
                    <div className="absolute top-1/2 left-1/2 flex flex-col items-center transform -translate-x-1/2 -translate-y-1/2">
                        <Link className="text-green-300 hover:text-yellow-600 mb-10" to="#about" onClick={changeNavbarStatus}>About</Link>
                        {/* <Link className="text-green-200 hover:text-yellow-600 mb-10" to="#experience" onClick={changeNavbarStatus}>Experience</Link> */}
                        <Link className="text-green-300 hover:text-yellow-600 mb-10" to="#projects" onClick={changeNavbarStatus}>Projects</Link>
                        <Link className="text-green-300 hover:text-yellow-600 mb-10" to="#skills" onClick={changeNavbarStatus}>Skills</Link>
                        <Link className="text-green-300 hover:text-yellow-600 mb-10" to="/blogs" onClick={changeNavbarStatus}>Blogs</Link>
                        <Link className="text-green-300 hover:text-yellow-600 mb-10" to="#contact" onClick={changeNavbarStatus}>Contact</Link>
                    </div>
                    {/* <div className="absolute h-0 w-screen  bg-green-500 group-hover:h-screen"></div> */}
                </div>
            }
        </div>
    )
}
